import { getBrowserWindow } from '../../cohesion/browser-window';
import type { TagularBeamClient, TagularWireName } from './types';

export function createDefaultTagularClient(): TagularBeamClient {
  return {
    isAvailable(): boolean {
      const win = getBrowserWindow();
      if (!win) {
        return false;
      }

      if (typeof win.tagular !== 'function') {
        return false;
      }

      const cohesionTagular = win._Cohesion?.tagular;
      if (!cohesionTagular?.sourceKey || !cohesionTagular?.writeKey) {
        return false;
      }

      return true;
    },

    beam(_eventName: TagularWireName, payload: Record<string, unknown>): void {
      if (!this.isAvailable()) {
        return;
      }

      // Cohesion SDK: tagular('beam', eventObject) — @type lives on the payload.
      getBrowserWindow()?.tagular?.('beam', payload);
    },
  };
}
